// extracted by mini-css-extract-plugin
export default {"title":"Cart_title__cdQiQ","cart_block":"Cart_cart_block__Lr4VD","help_item":"Cart_help_item__FnfnH","hr":"Cart_hr__txYOX","total_price":"Cart_total_price__MmZF3"};